import React from 'react';
import styles from './PromoCodeBanner.module.css';

const PromoCodeBanner = () => {
	return (
		<div className={`${styles['promo-code-banner']} py-3 text-center`}>
			Use promo code <strong>SAVE20</strong> to get 20% off your purchase!
		</div>
	);
};

export default PromoCodeBanner;